import React from 'react';
import { Tooltip } from 'antd';
import type { BoardIssueVo } from 'types/insuranceBilling';
import s from './s.module.less';

// ISSUES 列（原型 09/10 新增）。STATUS 说的是「处在哪个阶段」，这一列说的是
// 「具体什么东西要修」—— 缺诊断码、患者没打标签、payer 给的拒付原因……
// 文案由服务端给（issues[].label），一行可以有好几条：单行截断 + hover 出全量，
// 这样列再长也不会把行高撑开。
const IssuesCell = ({ issues }: { issues: BoardIssueVo[] }) => {
    if (!issues.length) return <span className={s.mutCell}>—</span>;

    const labels = issues.map((i) => i.label);
    const text = labels.join(', ');
    return (
        <Tooltip
            title={
                labels.length > 1 ? (
                    <ul className={s.issueTipList}>
                        {issues.map((i) => (
                            <li key={i.code}>{i.label}</li>
                        ))}
                    </ul>
                ) : (
                    text
                )
            }
        >
            <span className={s.issueCell}>{text}</span>
        </Tooltip>
    );
};

export default IssuesCell;
